import styled from 'styled-components';

export const StyledGrid = styled.div`
  display: flex;
  grid-gap: ${(p) => p.gap};
  flex-direction: ${(p) => p.col && 'column'};
`;
